import { getTemplate } from "./modules/utilities";


document.querySelector('#js-load-more button').addEventListener("click", function(event) {
  event.preventDefault();

  console.log('Click');
  let catId = this.getAttribute("data-cat") ? this.getAttribute("data-cat") : "";

  let url =
    window.location.protocol +
    "//" +
    window.location.hostname +
    ":" +
    window.location.port +
    "/ajax/blog-list/";

  if (catId !== "") {
    url = url + catId + "/";
  }

  getTemplate(url, "js-blog-container", "js-load-more");
});
